/**
 * Find which section contains the active route using path prefix matching.
 * Returns the section ID with the longest matching href prefix, or undefined.
 */
export function findActiveSectionId(
  pathname: string,
  sections: Array<{ id: string; items: Array<{ href: string }> }>
): string | undefined {
  let bestMatch: { sectionId: string; prefixLength: number } | undefined;

  for (const section of sections) {
    for (const item of section.items) {
      // Exact match or prefix match (pathname starts with href + '/')
      const isMatch =
        pathname === item.href ||
        (item.href !== '/' && pathname.startsWith(item.href + '/')) ||
        (item.href !== '/' && pathname.startsWith(item.href));

      if (isMatch) {
        const prefixLength = item.href.length;
        if (!bestMatch || prefixLength > bestMatch.prefixLength) {
          bestMatch = { sectionId: section.id, prefixLength };
        }
      }
    }
  }

  return bestMatch?.sectionId;
}
